const AUTHOR_CLASS_NAME = 'author'; // (Preview mode only, not editor)

export const isAuthorMode = () => document?.documentElement.classList.contains(AUTHOR_CLASS_NAME);

export const isLocalDomain = () => Boolean(window?.location.origin.match(/localhost/g));
